// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  display: inline-block;
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  margin: 0 0 0 0;
  padding: 0 0 0 0;
  border: 0;
  float: left;
}

.search-table {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Hub.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["ul {\n  display: inline-block;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\nli {\n  margin: 0 0 0 0;\n  padding: 0 0 0 0;\n  border: 0;\n  float: left;\n}\n\n.search-table {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
